import styled from 'styled-components';

import DashboardCardStyles from '@/features/Dashboard/components/styles/DashboardCardStyles';
import { DashboardTextContentStyle } from '@/features/Dashboard/components/styles/TextContentStyle';

const { StyledDashboardCardWrapper } = DashboardCardStyles;

type Props = {
  text: string;
};

const StaticDashboard2TextCard = (props: Props) => {
  return (
    <StyledDashboardCardWrapper
      className="break-inside-avoid"
      isDragging={false}
      width="auto"
      style={{ overflow: 'hidden' }}
    >
      <TextDisplay
        dangerouslySetInnerHTML={{
          __html: props.text,
        }}
      />
    </StyledDashboardCardWrapper>
  );
};

const TextDisplay = styled.div`
  padding: 16px;
  ${DashboardTextContentStyle};
`;

export default StaticDashboard2TextCard;
